import ServiceBase from './ServiceBase';

import { convertArrayParamsToCommaSeparatedList } from '@/Utils/FiltersUtility';

export default class PledgeService extends ServiceBase {
    constructor($http) {
        super($http);
    }

    authorizeDeferredPayment(paymentModel, projectID, providerPaymentID, numberOfInstallments) {
        const model = {
            projectID,
            providerPaymentID,
            numberOfInstallments,
            ...paymentModel,
        };

        return this.request('post', 'pledge/authorizeDeferredPayment', model);
    }

    authorizeDeferredPaymentChange(paymentModel, projectID, orderCode) {
        const model = {
            projectID,
            orderCode,
            ...paymentModel,
        };

        return this.request('post', 'pledge/authorizeDeferredPaymentChange', model);
    }

    authorizeInstantPayment(paymentModel, projectID, orderCode, checkoutMode, providerPaymentID) {
        const model = {
            projectID,
            orderCode,
            checkoutMode,
            providerPaymentID,
            ...paymentModel,
        };
        return this.request('post', 'pledge/authorizeInstantPayment', model);
    }

    createDeferredPayment(paymentModel, projectID, reCaptchaToken, reCaptchaAction, isInTestMode) {
        const model = {
            projectID,
            isInTestMode,
            reCaptchaToken,
            reCaptchaAction,
            ...paymentModel,
        };

        return this.request('post', 'pledge/createDeferredPayment', model);
    }

    changeDeferredPayment(paymentModel, projectID, orderCode, reCaptchaToken, reCaptchaAction, isInTestMode) {
        const model = {
            projectID,
            orderCode,
            isInTestMode,
            reCaptchaToken,
            reCaptchaAction,
            ...paymentModel,
        };

        return this.request('post', 'pledge/changeDeferredPayment', model);
    }

    createInstantPayment(paymentModel, projectID, orderCode, checkoutMode, reCaptchaToken, reCaptchaAction, isInTestMode) {
        const model = {
            projectID,
            orderCode,
            checkoutMode,
            isInTestMode,
            reCaptchaToken,
            reCaptchaAction,
            ...paymentModel,
        };

        return this.request('post', 'pledge/createInstantPayment', model);
    }

    amendPaidPledgeWithoutPayment(orderCode, projectID, appliedGiftCardIDs = []) {
        const model = {
            appliedGiftCardIDs,
            orderCode,
            projectID,
        };
        return this.request('post', 'pledge/amendPaidPledgeWithoutPayment', model);
    }

    createPledgeWithoutPayment(projectID, appliedGiftCardIDs = []) {
        const model = {
            appliedGiftCardIDs,
            projectID,
        };
        return this.request('post', 'pledge/createPledgeWithoutPayment', model);
    }

    getDynamicConversionCurrencies(projectID, projectLocationID, orderCode, appliedGiftCardIDs = []) {
        const params = convertArrayParamsToCommaSeparatedList({
            appliedGiftCardIDs,
            projectID,
            projectLocationID,
            orderCode,
        });

        return this.request('get', 'pledge/getDynamicConversionCurrencies', params);
    }

    getAvailablePaymentMethods({
        projectID,
        currencyShortName,
        locationIsoCode,
        orderCode,
        reason,
        paymentProvider,
        appliedGiftCardIDs = [],
    }) {
        return this.request('get', 'pledge/getAvailablePaymentMethods', convertArrayParamsToCommaSeparatedList({
            appliedGiftCardIDs,
            projectID,
            currencyShortName,
            locationIsoCode,
            orderCode,
            reason,
            paymentProvider,
        }));
    }

    getAvailablePaymentTypes(projectID, orderCode, checkoutMode, appliedGiftCardIDs = []) {
        return this.request('get', 'pledge/getAvailablePaymentTypes', convertArrayParamsToCommaSeparatedList({
            appliedGiftCardIDs,
            projectID,
            orderCode,
            checkoutMode,
        }));
    }

    payRemainingInstallments(orderCode, installmentPlanID) {
        return this.request('post', 'pledge/payRemainingInstallments', { orderCode, installmentPlanID });
    }

    retryInstallmentPayment(paymentID, orderCode) {
        return this.request('post', 'pledge/retryInstallmentPayment', { paymentID, orderCode });
    }

    grantOrderAccess(email, projectID, createUserAccount, reCaptchaToken, reCaptchaAction) {
        return this.request('post', 'pledge/grantOrderAccess', {
            email,
            projectID,
            createUserAccount,
            reCaptchaAction,
            reCaptchaToken,
        });
    }

    getPaymentAmountDetails(
        orderCode,
        paymentType,
        projectID,
        dynamicCurrencyID = null,
        exchangeRate = null,
        appliedGiftCardIDs = [],
    ) {
        const params = convertArrayParamsToCommaSeparatedList({
            appliedGiftCardIDs,
            orderCode,
            paymentType,
            projectID,
            dynamicCurrencyID,
            exchangeRate,
        });

        return this.request('get', 'pledge/getPaymentAmountDetails', params);
    }
}
